

























import Vue from 'vue';
import Component from 'vue-class-component';

/**
 *
 *  Button that is used to invoke the action of adding a new space.
 *
 *  (i) Used in the step heading and empty message.
 *
 */
@Component
export default class SpaceAddButton extends Vue {}
